import moment from "moment";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Table from "./Table";

export const getWeekTotal = (week) =>
	Object
		.values(week.data)
		.reduce((total, item) => ({
			duration: total.duration + (item.duration || item.otherDuration),
			total: total.total + item.total,
		}), { duration: 0, total: 0 });

function Week({ week, isSameDay, canViewRates }) {
	const { t } = useTranslation();

	const data = useMemo(
		() => Object.values(week.data),
		[week.data],
	);

	let dateContent = '';
	const sameDate = moment(week.startDate).isSame(week.endDate, "date");
	const sameMonth = moment(week.startDate).isSame(week.endDate, "month");
	const sameYear = moment(week.startDate).isSame(week.endDate, "year");

	if (sameDate) {
		dateContent = moment(week.startDate).format("MMM DD, YYYY");
	} else if (sameMonth) {
		dateContent = moment(week.startDate).format("MMM DD") + ` - ${moment(week.endDate).format("DD, YYYY")}`;
	} else if (sameYear) {
		dateContent = moment(week.startDate).format("MMM DD") + ` - ${moment(week.endDate).format("MMM DD, YYYY")}`;
	} else {
		dateContent = moment(week.startDate).format("MMM DD, YYYY") + ` - ${moment(week.endDate).format("MMM DD, YYYY")}`;
	}

	return (
		<div className='timeline-block'>
			<span className='timeline-step badge-info' />

			<div className='timeline-content mw-100'>
				{!isSameDay && (
					<small className='text-muted font-weight-bold mb-2'>
						{t("weekly-summary")}:

						{" "}

						{dateContent}
					</small>
				)}

				<Table data={data} canViewRates={canViewRates} />
			</div>
		</div>
	);
}

export default Week;
